



export const defaultSkillData = [
  "JavaScript",
  "Python",
  "PHP",
  "HTML",
  "CSS",
  "SQL",
  "React",
  "Redux",
  "Express",
  "Flask",
  "Django",
  "Node.js",
  "Markdown",
  "JSON",
  "Bash script",
  "Git",
  "Windows",
  "Linux",
  "Docker",
];
